export interface EventMapping {
  id?: number
  inbound_event: string
  outbound_event: string
  value: number
  action_source?: string
  send_method?: string
  event_provider?: string
}

export type PixelPlatform = 'facebook' | 'tiktok' | 'snapchat' | 'google'

export const pixelPlatformOptions: { value: PixelPlatform; label: string }[] = [
  { value: 'facebook', label: 'Facebook' },
  { value: 'tiktok', label: 'TikTok' },
  { value: 'snapchat', label: 'Snapchat' },
  { value: 'google', label: 'Google' },
]

export interface CredentialPayload {
  credential_type: string
  auth_url?: string
  refresh_token_url?: string
  api_token?: string
  api_key?: string
  refresh_token?: string
}

export interface Pixel {
  id: number
  name: string
  platform?: PixelPlatform
  pixel_id: string
  api_token?: string
  flow_ids?: (number | null)[]
  partner_id: number
  credential_id: number
  partner?: {
    id: number
    name: string
    affiliate_id?: number
    created_at: string
    updated_at: string
  }
  credential?: {
    id: number
    credential_type: string
    created_at: string
    updated_at: string
  }
  event_mappings: EventMapping[]
  created_at: string
  updated_at: string
}

export const ourEvents = [
  // FE events
  'session_start',
  'step_1_loaded',
  'step_1_completed',
  'step_2_loaded',
  'step_2_completed',
  'step_3_loaded',
  'step_3_completed',
  'step_4_loaded',
  'step_4_completed',
  'step_5_loaded',
  'step_5_completed',
  'chat_loaded',
  'chat_started',
  'lead_submit',
  'downsell',
  // BE events
  'lead_accepted',
  'lead_rejected',
  'appointment',
  'on_call',
  'quoted',
  'sold',
  'dnq',
  'dnc',
  'transferred',
  'enrollment',
  'soft_pull_qualified',
  'soft_pull_unqualified',
] as const

export const fbEvents = [
  'AddToCart',
  'InitiateCheckout',
  'AddPaymentInfo',
  'Purchase',
] as const

export const fbActionSources = [
  'website',
  'app',
  'phone_call',
  'chat',
  'email',
  'physical_store',
  'system_generated',
  'other',
] as const

export const defaultEventMappings: EventMapping[] = [
  {
    inbound_event: 'Lead',
    outbound_event: 'AddToCart',
    value: 1,
    action_source: 'website',
  },
  {
    inbound_event: 'Appointment',
    outbound_event: 'InitiateCheckout',
    value: 5,
    action_source: 'system_generated',
  },
  {
    inbound_event: 'OnCall',
    outbound_event: 'AddPaymentInfo',
    value: 25,
    action_source: 'phone_call',
  },
  {
    inbound_event: 'Quoted',
    outbound_event: 'Purchase',
    value: 100,
    action_source: 'system_generated',
  },
  {
    inbound_event: 'Sold',
    outbound_event: 'Purchase',
    value: 500,
    action_source: 'system_generated',
  },
]
